import * as React from "react";
const SvgDoorStraight = (props) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 16 16", ...props }, /* @__PURE__ */ React.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M13 0H3v13H1v2h14v-2h-2zM5 9h2V7H5z", clipRule: "evenodd" }));
export default SvgDoorStraight;
